<ng-container *ngIf="pot">
    <div class="amount">{{pot.amount}}€</div>

    <div *ngFor="let player of pot.players">
        {{player.name}}
    </div>
</ng-container>
